// extracted by mini-css-extract-plugin
export default {"section":"DeptTab_section__WLAD3","title":"DeptTab_title__FjH3E"};